var map = {
	"./android/detection": 1019,
	"./androidtv/detection": 1020,
	"./arris/detection": 1021,
	"./hisense/detection": 1022,
	"./kepler/detection": 1023,
	"./lg/detection": 1024,
	"./nagra/detection": 1025,
	"./netrange/detection": 1026,
	"./opera/detection": 1027,
	"./polaroid/detection": 1028,
	"./ps4/detection": 1029,
	"./samsung/detection": 1030,
	"./seirobotics/detection": 1031,
	"./sony/detection": 1032,
	"./stbcoship/detection": 1033,
	"./stbcoship9108/detection": 1034,
	"./stbhuawei/detection": 1035,
	"./stbkaon/detection": 1036,
	"./tizen/detection": 1037,
	"./web0s/detection": 1038,
	"./workstation/detection": 1039,
	"./workstationChafari/detection": 1040,
	"./zeasn/detection": 1041,
	"./zte/detection": 1042
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1018;


//////////////////
// WEBPACK FOOTER
// ./src/devices ^\.\/.*\/detection$
// module id = 1018
// module chunks = 0